var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"id":"doc"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('road-map')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }